import React, { useMemo } from 'react'
import { filterBlockByType, isEmpty } from '../../../services/common'
import { Parser } from '../../common'
import Dropdown from '../dropdown/Dropdown'

const CanHelpMeItemDropDown = ({ block, index }) => {
    const blockChildrens = useMemo(() => {
        return isEmpty(block?.childrens) ? block?.attributes?.original_childrens : block?.childrens
    }, [block?.childrens])

    const blockText = filterBlockByType(blockChildrens, 'Texte')
    const blockTitle = filterBlockByType(blockChildrens, 'Titre')
    const [openBlockText, setOpenBlockText] = React.useState(false)

    return !isEmpty(blockText) ? (
        <Dropdown
            onClickOpen={() => setOpenBlockText(!openBlockText)}
            title={blockTitle?.content}
            className="baseocom-can-help-me-dropdown"
            isOpen={openBlockText}
            variable={`can-help-me-${block?.ID}-dropdown-height`}
        >
            <div className="baseocom-content">
                {blockText && <Parser content_block={blockText?.childrens} />}
            </div>
        </Dropdown>
    ) : null
}

export default CanHelpMeItemDropDown
